import React from "react";
import { H1 as EdenH1, H2 as EdenH2, H3 as EdenH3, H4 as EdenH4, H5 as EdenH5, H6 as EdenH6 } from "@churchofjesuschrist/eden-headings";
import { spacing8, spacing16, spacing32, spacing64 } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";
const SpacedH1 = styled(EdenH1).withConfig({
  componentId: "sc-1x40v1g-0"
})(["margin-block-start:", ";margin-block-end:", ";"], spacing64, spacing16);
const SpacedH2 = styled(EdenH2).withConfig({
  componentId: "sc-1x40v1g-1"
})(["margin-block-start:", ";margin-block-end:", ";"], spacing64, spacing16);
const SpacedH3 = styled(EdenH3).withConfig({
  componentId: "sc-1x40v1g-2"
})(["margin-block-start:", ";margin-block-end:", ";h2 + &{margin-block-start:", ";}"], spacing32, spacing8, spacing16);
const SpacedH4 = styled(EdenH4).withConfig({
  componentId: "sc-1x40v1g-3"
})(["margin-block-start:", ";margin-block-end:", ";h3 + &{margin-block-start:", ";}"], spacing32, spacing8, spacing8);
const SpacedH5 = styled(EdenH5).withConfig({
  componentId: "sc-1x40v1g-4"
})(["margin-block-start:", ";margin-block-end:", ";h4 + &{margin-block-start:", ";}"], spacing32, spacing8, spacing16);
const SpacedH6 = styled(EdenH6).withConfig({
  componentId: "sc-1x40v1g-5"
})(["margin-block-start:", ";margin-block-end:", ";h5 + &{margin-block-start:", ";}"], spacing32, spacing8, spacing16);
const ComponentMappings = {
  H1: SpacedH1,
  H2: SpacedH2,
  H3: SpacedH3,
  H4: SpacedH4,
  H5: SpacedH5,
  H6: SpacedH6
};

const getWrappedHeadingComponent = level => {
  const Component = ComponentMappings[level];

  const WrappedHeading = _ref => {
    let { ...props
    } = _ref;
    return /*#__PURE__*/React.createElement(Component, props);
  };

  return WrappedHeading;
};

export const H1 = getWrappedHeadingComponent("H1");
export const H2 = getWrappedHeadingComponent("H2");
export const H3 = getWrappedHeadingComponent("H3");
export const H4 = getWrappedHeadingComponent("H4");
export const H5 = getWrappedHeadingComponent("H5");
export const H6 = getWrappedHeadingComponent("H6");